import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新无删减漫画章节，下拉式阅读体验</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="bg-background-50 rounded-lg overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 border-b border-background-200/70 text-xs font-medium text-foreground-500">
            <div className="col-span-5">漫画</div>
            <div className="col-span-4">最新章节</div>
            <div className="col-span-3 text-right">更新时间</div>
          </div>

          {latestUpdates.map((item, index) => (
            <Link
              key={item.id}
              to={`/comic/${item.comicSlug}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-5 py-3.5 items-center hover:bg-background-100 transition-colors cursor-pointer ${
                index < latestUpdates.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className="md:col-span-5 flex items-center gap-3">
                <span className={`text-xs font-bold w-5 text-center ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-sm font-medium text-foreground-800 truncate">{item.comicTitle}</span>
                {index < 3 && (
                  <span className="text-xs bg-primary-100 text-primary-700 px-1.5 py-0.5 rounded whitespace-nowrap">NEW</span>
                )}
              </div>
              <div className="md:col-span-4">
                <span className="text-sm text-foreground-600 truncate block">{item.chapterTitle}</span>
              </div>
              <div className="md:col-span-3 md:text-right">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.updateTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}